import { Pipe, PipeTransform } from '@angular/core';
import { formatBusinessNumber, formatContactNumber } from '@millionshow/common';

@Pipe({
  name: 'formatPhone',
  standalone: true,
})
export class FormatPhonePipe implements PipeTransform {
  transform(value: string | null | undefined, defaultValue = '-'): string {
    if (!value) return defaultValue;
    return formatContactNumber(value);
  }
}

@Pipe({
  name: 'formatBusinessNumber',
  standalone: true,
})
export class FormatBusinessNumberPipe implements PipeTransform {
  transform(value: string | null | undefined, defaultValue = '-'): string {
    if (!value) return defaultValue;
    return formatBusinessNumber(value);
  }
}
